export function popFrontURL(url: any, popNumber: number) {
    return url.split('/').slice(popNumber).join('/') + '/';
}
